export default __webpack_public_path__ + "static/media/Screenshot 2024-07-31 at 1.33.42â¯PM.d0f336f7.png";